import type { LegacySubscription } from '../../types';

import { hasPlan } from './hasPlan';

export function isActiveTrialWithNoPlan(legacySubscription: LegacySubscription) {
  return !!(hasPlan(legacySubscription) && legacySubscription.isTrial);
}
